export default __webpack_public_path__ + "static/media/accounting-icon.d2c7a5ba.svg";